import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchAgroExporterProcess(agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/production/query_container_export/show_process/fetch_agro_exporter_process/${agro_exporter_process_id}`
    );
  },
  fetchExportation(exportation_id) {
    return RequesterV1.get(
      `agro_exporter/production/query_container_export/show_exportation/fetch_exportation/${exportation_id}`
    );
  },
  fetchExportationAttachments(exportation_id) {
    return RequesterV1.get(
      `agro_exporter/production/query_container_export/show_exportation/fetch_exportation_attachments/${exportation_id}`
    );
  },
  downloadExportationRepXlsx(exportation_id) {
    return RequesterV1.get(
      `agro_exporter/production/query_container_export/show_exportation/exportation_rep_xlsx/${exportation_id}`,
      { responseType: "blob" }
    );
  },
  downloadExportationAttachment(exportation_id, exportation_attachment_id) {
    return RequesterV1.get(
      `agro_exporter/production/query_container_export/show_exportation/download_exportation_attachment/${exportation_id}/${exportation_attachment_id}`,
      { responseType: "blob" }
    );
  }
};
